import React from "react";
import { faqs } from "../data/landing";
import { SectionHead } from "./SectionHead";
export function Faq() {
  return <section className="card" data-id="element-32" data-mp="1qa3ilvw9kz1l">
      <SectionHead kicker="PERGUNTAS FREQUENTES" title="Tudo o que você precisa saber" subtitle="Ficou alguma dúvida? As respostas mais comuns estão aqui." data-id="element-33" data-mp="1q8sge0igvzcl" />
      <div className="faw" data-id="element-34" data-mp="1geikw9y8akxn">
        {faqs.map(f => <details className="fa" key={f.q} data-id="element-35" data-mp="2e0ppvkyg2faj">
            <summary data-id="element-36" data-mp="2dydb1gnzgl1p">{f.q}</summary>
            <p data-id="element-37" data-mp="291mlm2qagd3m">{f.a}</p>
          </details>)}
      </div>
    </section>;
}